import React from 'react'
import styled from 'styled-components'
import { markidimLogo } from '@assets/images'

const markidimUrl = 'http://www.markid.co.il/'

export default () => {
    const handleLogoClick = () => {
        var win = window.open(markidimUrl, '_blank')
        win.focus()
    }

    return (
        <HeaderTopPart>
            <TopPartTexts>
                <HebHeader>
                    ארגון המדריכים והיוצרים לריקודי עם בישראל ובתפוצות (ע"ר)
                </HebHeader>
                <EnglishHeader>
                    Association of Folk Dance instructors & choreographers in
                    Israel and abroad
                </EnglishHeader>
            </TopPartTexts>
            <LogoImageButton onClick={handleLogoClick}>
                <LogoImage src={markidimLogo} />
            </LogoImageButton>
        </HeaderTopPart>
    )
}

const HeaderTopPart = styled.div`
    width: 100%;
    display: flex;
    padding: 8px 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;

    @media (max-width: 768px) {
        display: none;
    }
`
const LogoImage = styled.img`
    height: 60px;
`

const LogoImageButton = styled.button`
    border-width: 0.1px;
    border-color: transparent;
    background-color: transparent;
`

const HebHeader = styled.div`
    font-size: 27px;
    color: #521d50;
    font-weight: 400;
    margin-bottom: 4px;
`
const TopPartTexts = styled.div``

const EnglishHeader = styled.div`
    display: block;

    color: rgb(152, 135, 152);
    width: 100%;
    text-align: center;
    @media (max-width: 768px) {
        font-size: 1rem;
    }
`
